var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elm,_vm._b({tag:"component",staticClass:"pmw-link",on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }